import { render, staticRenderFns } from "./validBase.htm?vue&type=template&id=481a3c81&"
import script from "./NumInput.vue?vue&type=script&lang=js&"
export * from "./NumInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports